import { Link } from 'react-router-dom';
import useReveal from '../components/useReveal';
import { works } from '../data/works';
import { usePosts } from '../hooks/usePosts';
import coverImage from '../data/images/cover.png';
import coverImageHome from '../data/images/works_img/movements-main.jpeg';

function Reveal({ children, delay = 0, className = '' }) {
  const ref = useReveal();
  return (
    <div ref={ref} className={`reveal ${className}`} style={{ transitionDelay: `${delay}ms` }}>
      {children}
    </div>
  );
}

function RevealBlock({ children, className = '', delay = 0 }) {
  const ref = useReveal();
  return (
    <div ref={ref} className={`reveal ${className}`} style={{ transitionDelay: `${delay}ms` }}>
      {children}
    </div>
  );
}

export default function Home() {
  const { posts } = usePosts();
  const HARDCODED_LATEST_POST_ID = 'the-self-portrait-of-an-AI-blog';

  const latestPost = posts?.find(
    p =>
      (p.id || p.slug) === HARDCODED_LATEST_POST_ID &&
      p.title &&
      p.date
  );

  return (
    <div className="pt-16">

      {/* ── HERO ── */}
      <section className="grid grid-cols-1 md:grid-cols-2 min-h-[92vh] border-b border-cream-400/60 bg-gradient-to-b from-[#F7F4EF]  via-[#FCFAF2] to-[#FFFBEA]">
        <div className="flex flex-col justify-center px-6 sm:px-10 md:px-16 lg:px-20 py-16 border-b md:border-b-0 md:border-r border-cream-400/60">
          <Reveal><p className="label mb-6">Artist & Creative Technologist</p></Reveal>
          <Reveal delay={100}>
            <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal leading-[1.05] text-ink mb-6">
              On Intuition.<br />
              Impressions of knowledge, feeling<br />
              <em>and emotions.</em>
            </h1>
          </Reveal>
          <Reveal delay={200}>
            <p className="font-sans text-base text-stone-warm leading-relaxed max-w-sm mb-10">
              I make sensor driven interractive installations that explore the relationship between people and their environments, often site-specific and designed to
              evolve with time.
            </p>
          </Reveal>
          <Reveal delay={300}>
            <div className="flex gap-8">
              <Link to="/works" className="label border-b border-ink text-ink pb-0.5 hover:opacity-60 transition-opacity">
                See Works →
              </Link>
              <Link to="/blog" className="label border-b border-stone-muted text-stone-muted pb-0.5 hover:text-ink hover:border-ink transition-colors">
                Read blogs →
              </Link>
            </div>
          </Reveal>
        </div>

        <img
          src={coverImage}
          alt="Cover artwork"
          className="w-full h-full object-contain"
        />
      </section>

      {/* ── INSTALLATIONS ── */}
      <section className="border-b border-cream-400/60  bg-gradient-to-b from-[#FFFBEA] via-[#F8F3D6] to-[#FFFDF5]">
        <div className="px-6 sm:px-10 md:px-16 lg:px-20 py-5 border-b border-cream-400/60 flex items-center justify-between">
          <span className="label text-stone-dark">Works</span>
          <Link to="/works" className="label text-ink hover:text-stone-warm transition-colors">View all →</Link>
        </div>

        {/* Featured installation */}
        <div className="grid grid-cols-1 md:grid-cols-2 border-b border-cream-400/60">
          <div className="aspect-video md:aspect-auto min-h-64 overflow-hidden flex items-center p-10 justify-center border-b md:border-b-0 md:border-r border-cream-400/60">
          
              <img src={coverImageHome } alt={works[3].title} className="w-1/2 h-auto object-cover group-hover:scale-105 transition-transform duration-200" />
          </div>
          <Reveal className="flex flex-col justify-end p-6 sm:p-10 md:p-16">
            <span className="font-mono text-[14px] text-stone-dark tracking-widest2 block mb-8">{works[3].status} | {works[3].year} | {works[3].location}</span>
            <div className="flex gap-2 flex-wrap mb-5">
              {works[3].tags.map(t => (
                <span key={t} className="label px-2 py-0.5 border border-cream-400/60 text-stone-dark">{t}</span>
              ))}
            </div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-normal leading-tight mb-4">
              {works[3].title}
            </h2>
            <p className="font-sans text-sm text-stone-dark leading-relaxed mb-6 max-w-sm">
              {works[3].description}
            </p>
            <div className="flex gap-6 items-center flex-wrap">
              {(works[3].blogId || works[3].writingId) && (
                <Link to={`/blog/${works[3].blogId || works[3].writingId}`}
                  className="label text-stone-dark hover:text-stone-warm transition-colors">
                  Read Blog →
                </Link>
              )}
            </div>
          </Reveal>
        </div>

        {/* Remaining installations */}
        {/* <div className="grid grid-cols-1 sm:grid-cols-3">
          {works.slice(2, 5).map((work, i) => (
            <Link key={work.id} to={`/works/${work.id}`}
              className={`group border-r border-cream-400/60 p-6 sm:p-8 flex flex-col gap-4 hover:bg-cream-200/50 transition-colors duration-200 ${i === 2 ? 'border-r-0' : ''}`}>
              <div className="aspect-[4/3] overflow-hidden">
                <InstallationGraphic id={work.id} dark={false} />
              </div>
              <div>
                <span className="font-mono text-[9px] text-stone-dark tracking-widest2 block mb-2">{work.num}</span>
                <h3 className="font-serif text-lg text-ink font-normal leading-tight mb-1">{work.title}</h3>
                <p className="label text-stone-dark">{work.year} · {work.location.split(',')[0]}</p>
              </div>
            </Link>
          ))}
        </div> */}
      </section>

      <section className="border-b border-cream-400/60 py-20 bg-gradient-to-b from-[#FFFDF5] via-[#FCFAF2] to-[#F7F4EF]">
        <div className="max-w-6xl mx-auto px-8">

          {/* Header */}
          <div className="flex justify-between items-center mb-16">
            <p className="label">Latest Writing</p>

            <Link
              to="/blog"
              className="label hover:opacity-60 text-ink transition-opacity"
            >
              View all →
            </Link>
          </div>

          {latestPost && (
            <div className="grid md:grid-cols-[280px_1fr] p-4 border border-stone-muted/60 gap-16 items-start">

              {/* Left */}
              <Link
                to={`/blog/${latestPost.id || latestPost.slug}`}
                className="group"
              >
                <div className="aspect-square border border-cream-40/60 bg-cream-200 flex items-center justify-center">
<img src={latestPost.coverImage || '/img/blog1.png'} alt={latestPost.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200" />
                </div>

                <h3 className="font-serif text-2xl mt-6 group-hover:opacity-70 transition-opacity">
                  {latestPost.title}
                </h3>
              </Link>

              {/* Right */}
              <div className="max-w-lg ">

                <p className="font-sans text-stone-warm leading-relaxed mb-8">
                  {latestPost.excerpt}
                </p>

                <div className="flex items-center gap-6 mb-6 flex-wrap">
                  {latestPost.tags.map(tag => (
                    <span
                      key={tag}
                      className="label border border-cream-400/60 px-2 py-1 bg-[#F8F3D6] text-ink"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <Link
                  to={`/blog/${latestPost.id || latestPost.slug}`}
                  className="label border-b border-ink pb-0.5"
                >
                  Read article →
                </Link>

                <p className="label mt-5 text-stone-muted">
                  {latestPost.readTime} · {latestPost.date}
                </p>

              </div>

            </div>
          )}

        </div>
      </section>


      {/* ── ABOUT / DISCIPLINES TEASER ── */}
      <section className="grid grid-cols-1 md:grid-cols-2">
        <div className="px-10 md:px-16 lg:px-20 py-20 ">
          <RevealBlock>
            <p className="label mb-6">About</p>
            <blockquote className="font-serif text-xl md:text-2xl text-ink leading-relaxed font-normal">
              "I think of every project as a conversation between a system and its environment —
              whether that system is code, sensors, or pigment on paper."
            </blockquote>
            <div className="mt-10">
              <Link to="/about" className="label text-ink pb-0.5 hover:opacity-60 transition-opacity">
                More about me →
              </Link>
            </div>
          </RevealBlock>
        </div>
        <div className="px-10 md:px-16 lg:px-20 py-20 ">
          <RevealBlock>
            <p className="label mb-6">Disciplines</p>
            <ul className="divide-y divide-cream-400/60">
              {[
                ['Interactive Installation', '2026 – current'],
                ['Sensor Systems Design', '2025 – current'],
                ['Creative Research', '2024 – current'],
                ['Software Development for Hardware ecosystems', '2023 – 2025'],
                ['Software Engineering', '2019 – 2023'],

              ].map(([skill, yr]) => (
                <li key={skill} className="flex items-center justify-between py-3">
                  <span className="font-sans text-sm text-ink">{skill}</span>
                  <span className="label text-stone-muted">{yr}</span>
                </li>
              ))}
            </ul>
          </RevealBlock>
        </div>
      </section>


    </div>
  );
}
